function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-1{fill:#cc2264;}.cls-2{fill:#fff;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "AWS-Auto-Scaling_light-bg");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Reference"
}, React.createElement("rect", {
  id: "Pink_Light_BG",
  "data-name": "Pink Light BG",
  className: "cls-1",
  width: 75,
  height: 75
}), React.createElement("g", {
  id: "Product_Icon",
  "data-name": "Product Icon"
}, React.createElement("path", {
  className: "cls-2",
  d: "M36.5,16v9.45h2V16l4.66,4.65,1.41-1.41-6.36-6.37a1,1,0,0,0-1.42,0l-6.36,6.37,1.41,1.41Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M38.5,59V49.43h-2V59l-4.66-4.66-1.41,1.42,6.36,6.36a1,1,0,0,0,1.42,0l6.36-6.36-1.41-1.42Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M18.77,30.42l-1.41,1.42L22,36.43H12.5v2h9.59l-4.73,4.72,1.41,1.41,6.37-6.36a1,1,0,0,0,0-1.41Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M62.5,36.43H53.05l4.59-4.59-1.42-1.42-6.36,6.37a1,1,0,0,0,0,1.41l6.36,6.36,1.42-1.41-4.73-4.72H62.5Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M46,32.05l-8-4.5a1,1,0,0,0-1,0l-8,4.5a1,1,0,0,0-.51.87v9a1,1,0,0,0,.51.87l8,4.49a.94.94,0,0,0,.48.13.91.91,0,0,0,.48-.13l8-4.49a1,1,0,0,0,.51-.87v-9A1,1,0,0,0,46,32.05ZM37.5,29.59l6,3.38-6,3.48-6-3.48Zm-7,5.12,6,3.47v6.5l-6-3.37Zm8,10V38.19l6-3.48v6.6Z"
})));

var SvgAwsAutoScaling = function SvgAwsAutoScaling(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    className: "svgCloudServices",
    viewBox: "0 0 75 75",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAwsAutoScaling, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/AWS-Auto_Scaling.5caa95af.svg";
export { ForwardRef as ReactComponent };